import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#2134de' },
    background: { default: '#ffffff' },
  },
  components: {
    MuiButton: { styleOverrides: { root: { borderRadius: 8, textTransform: 'none' } } },
    MuiAppBar: { styleOverrides: { colorPrimary: { backgroundColor: '#2134de' } } },
  },
  typography: {
    h1: { fontSize: '2.2rem', fontWeight: 800 },
    h2: { fontSize: '1.8rem', fontWeight: 700 },
    h3: { fontSize: '1.4rem', fontWeight: 700 },
    body1: { lineHeight: 1.7 }
  }
});

export default theme;
